import React, { useEffect, useState } from 'react';
import Header from '@components/Comman/Header';
import { Table, Tag, Button, Space, Empty, Spin, message } from 'antd';
import { BankOutlined, EyeOutlined } from '@ant-design/icons';
import type { ColumnsType } from 'antd/es/table';
import { useDispatch } from 'react-redux';
import { exportMyReferrersAction, getAllSuperAdminRefferers, getMyRefferersAction, getReferrerNotificationCount, paySuperAdminReferrers, sendEmailreminderToReferrerAction, updateReferrerNotificationCount } from '../../actions/refer';
import { useSelector } from 'react-redux';
import PageTitle from '@components/Comman/PageTitle';
import moment from 'moment';
import { capitalizeAfterComma, capitalizeFirstLetter, convertToBusinessFormat, isAdminEmail, truncateText } from '@utils/comman';
import SearchFilter from '@components/Comman/TableFilter/SearchFilter';
import PaymentModal from '../Acount/PaymentModal';
import { advanceFilterReferrerList } from '@utils/contstant';
import CardPagination from '@components/Comman/CardPagination';
import ListingCardReferrer from '@components/Comman/ListingCardReferrer/ListingCardReferrer';
import { deleteBusinessReferrerAction, deleteSuperAdminReferrerAction } from '../../actions/business';

interface DataType {
    key: string;
    firstName: string;
    lastName: string;
    email: string;
    businessCode: string;
    isRegistered: boolean;
}

const columnsN: ColumnsType<DataType> = [
    {
        title: 'Date Started',
        dataIndex: 'createdAt',
        key: 'createdAt',
        sorter: (a: any, b: any) => a.createdAt?.localeCompare(b?.createdAt),
        render: (text) => {
            return <>{moment(text).format('DD/MM/YYYY')}</>
        }
    },
    {
        title: 'First Name',
        dataIndex: 'invite',
        key: 'invite',
        sorter: (a: any, b: any) => a.invite?.firstName?.localeCompare(b?.invite?.firstName),
        render: (text) => {
            return <>{text?.firstName}</>
        }
    },
    {
        title: 'Last Name',
        dataIndex: 'invite',
        key: 'invite',
        sorter: (a: any, b: any) => a.invite?.lastName.localeCompare(b?.invite?.lastName),
        render: (text) => {
            return <>{text?.lastName}</>
        },
    },
    {
        title: 'Contact Number',
        dataIndex: 'contactNumber',
        key: 'contactNumber',
        sorter: (a: any, b: any) => a?.contactNumber.localeCompare(b?.contactNumber),
        render: (text) => {
            return <>{text}</>
        },
    },
    {
        title: 'Email',
        dataIndex: 'invite',
        key: 'invite',
        sorter: (a: any, b: any) => a.invite?.email?.localeCompare(b.invite?.email),
        render: (text) => {
            return <>{text?.email}</>
        },
    },
    {
        title: 'Business Code',
        dataIndex: 'senderCode',
        key: 'senderCode',
        sorter: (a: any, b: any) => a?.senderCode?.localeCompare(b?.senderCode),
        render: (text) => <>{text}</>,
    },
    {
        title: 'No. Of Referrals',
        dataIndex: 'referralsCount',
        key: 'referralsCount',
        sorter: (a: any, b: any) => a?.referralsCount?.localeCompare(b?.referralsCount),
        render: (text) => <>{text}</>,
    },
    {
        title: 'Date of last referrals',
        dataIndex: 'invite',
        key: 'invite',
        render: (record) => {
         return <>{record?.user?.referrals?.length ? moment(record?.user?.referrals?.[0]?.cretatedAt).format('DD/MM/YYYY') : ""}</>
        },
    },
    {
        title: 'Outstanding Payment',
        dataIndex: 'outstanding',
        key: 'outstanding',
        sorter: (a: any, b: any) => a?.outstanding?.localeCompare(b?.outstanding),
        render: (text) => <>{text ? <Tag color='red'>{text}</Tag> : <Tag color='green'>{text}</Tag>}</>,
    },
    {
        title: 'Total Income',
        dataIndex: 'totalIncome',
        key: 'totalIncome',
        sorter: (a: any, b: any) => a?.totalIncome?.localeCompare(b?.totalIncome),
        render: (text) => <>{text}</>,
    },
    {
        title: 'Action',
        key: 'action',
        render: (_, record) => (
            <Space size="middle">
                <Button type='link' onClick={() => console.log("View details", record)}>
                    <EyeOutlined />
                </Button>
            </Space>
        ),
    },
];

interface ReferrerType {
    adminId?: number
}

interface PayloadType {
    limit: number;
    page: number;
    role: number;
    admin_id?: number;
};

const MyReferrers = ({ adminId }: ReferrerType) => {
    const [data, setData] = useState<DataType[]>([]);
    const [pagination, setPagination] = useState({ totalItems: 0 });
    const [pageSize, setPageSize] = useState(12);
    const [showPaymentModal, setShowPaymentModal] = useState({show: false, data: {}});
    const [page, setPage] = useState(1);
    const dispatch = useDispatch();
    const userData = useSelector((state: any) => state?.Auth?.user);
    const userRoleId = userData?.data?.roleId;
    const { isLoading } = useSelector((state: any) => state?.General);
    let pageName =location?.pathname?.split('/')?.[2];
    let showOnlyTable = userRoleId === 1 && pageName === 'view-business-details'


    const getReferrerData=(payloadD: any)=> {
        let payload:any = { limit: pageSize, page, role: userRoleId, ...payloadD };

        if (showOnlyTable) {
            payload = { ...payload, admin_id: adminId }
        }

        if(userRoleId === 1) {
            const pathName = location?.pathname?.split('/')?.[2];
            payload.isBusiness = pathName === "my-referrers" ? false : true;
            dispatch(
                getAllSuperAdminRefferers(payload, (resp: any) => {
                    if (resp?.success) {
                        console.log("resp", resp)
                        setData(resp?.data);
                        setPagination(resp?.pagination);
                    }
                })
            );
        } else {
            dispatch(
                getMyRefferersAction(payload, (resp: any) => {
                    if (resp?.success) {
                        console.log("resp", resp)
                        setData(resp?.data);
                        setPagination(resp?.pagination);
                    }
                })
            );
        }
    }

    useEffect(() => {
        let payload: PayloadType = { limit: pageSize, page, role: userRoleId };
        getReferrerData(payload);
    }, [page, pageSize, dispatch]);

    useEffect(()=> {
        dispatch(updateReferrerNotificationCount({resetType: 'referrer', role: userRoleId}, (res:any)=>{
            if (userRoleId === 2) {
            dispatch(getReferrerNotificationCount({}, (res:any)=>{}))
            }
        }))
    }, [])

    const handleSendEmailReminder = (data: any) => {
        const payload = {
            invite_id: data?.invite_id,
        };
        dispatch(
            sendEmailreminderToReferrerAction(payload, (resp: any) => {
                if (resp?.status === 200) {
                    getReferrerData({})
                }
            })
        );
    };

    const handleTableChange = (pagination: any) => {
        // For super admin viewing business details, use pagination.current
        // For regular referrer list, use the entire pagination object
        if (showOnlyTable) {
            setPage(pagination.current);
            setPageSize(pagination.pageSize);
        } else {
            setPage(pagination);
            // setPageSize(pagination.pageSize);
        }
    };


    const superAdminColumns: ColumnsType<DataType> = [
        {
            title: 'First Name',
            dataIndex: 'firstName',
            key: 'firstName',
            sorter: (a: any, b: any) => a.firstName?.localeCompare(b?.firstName),
            render: (text) => {
                return <>{text}</>
            }
        },
        {
            title: 'Last Name',
            dataIndex: 'lastName',
            key: 'lastName',
            sorter: (a: any, b: any) => a.lastName.localeCompare(b?.lastName),
            render: (text) => {
                return <>{text}</>
            },
        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
            sorter: (a: any, b: any) => a.email?.localeCompare(b.email),
            render: (text) => {
                return <>{text}</>
            },
        },
        {
            title: 'Is Registered',
            dataIndex: 'isRegistered',
            key: 'isRegistered',
            sorter: (a: any, b: any) => Number(a?.isRegistered) - Number(b?.isRegistered),
            render: (text: any) => (
                <Tag color={text ? 'green' : 'red'}>
                    {text ? 'Yes' : 'No'}
                </Tag>
            ),
        },
        {
            title: 'Action',
            key: 'action',
            render: (_, record) => (
                <Space size="middle">
                    <Button type='link' onClick={() => console.log("View details", record)}>
                        <EyeOutlined />
                    </Button>
                </Space>
            ),
        },
    ];

    const columns: ColumnsType<DataType> = [
        {
            title: 'Date Started',
            dataIndex: 'createdAt',
            key: 'createdAt',
            sorter: (a: any, b: any) => a.createdAt?.localeCompare(b?.createdAt),
            render: (text) => {
                return <>{moment(text).format('DD/MM/YYYY')}</>
            }
        },
        {
            title: 'First Name',
            dataIndex: 'invite',
            key: 'invite',
            sorter: (a: any, b: any) => a.invite?.firstName?.localeCompare(b?.invite?.firstName),
            render: (text) => {
                return <>{capitalizeFirstLetter(text?.firstName)}</>
            }
        },
        {
            title: 'Last Name',
            dataIndex: 'invite',
            key: 'invite',
            sorter: (a: any, b: any) => a.invite?.lastName.localeCompare(b?.invite?.lastName),
            render: (text) => {
                return <>{capitalizeFirstLetter(text?.lastName)}</>
            },
        },
        {
            title: 'Mobile',
            dataIndex: '',
            key: '',
            render: (text) => {
                return isAdminEmail(text?.email) ? "" :  <>{text?.invite?.mobileNumber}</>
            },
        },
        {
            title: 'Email',
            dataIndex: 'invite',
            key: 'invite',
            sorter: (a: any, b: any) => a.invite?.email?.localeCompare(b.invite?.email),
            render: (text) => {
                return <>{text?.email}</>
            },
        },
        {
            title: 'Business Name',
            dataIndex: '',
            key: '',
            render: (text) => {
            return <>{isAdminEmail(text?.invite?.email) ? "ReferUs Network" : text?.invite?.referrerBusinessDetails?.businessName}</>
            },
        },
        {
            title: 'Business Service',
            dataIndex: 'invite',
            key: 'invite',
            render: (text) => {
                return isAdminEmail(text?.email) ? "Co-Founder" : <span title={text?.referrerBusinessDetails?.services}>{text?.referrerBusinessDetails?.services && truncateText(capitalizeFirstLetter(capitalizeAfterComma(text?.referrerBusinessDetails?.services)))}</span>
            },
        },
        {
            title: 'No Of Referrals',
            dataIndex: '',
            key: '',
            render: (text) => {
                return isAdminEmail(text?.invite?.email) ? "" : <>{text?.referralsCount}</>
            },
        },
        {
            title: 'Last Date Of Referrals',
            dataIndex: '',
            key: '',
            render: (record) => {
            return isAdminEmail(record?.invite?.email) ? "" :  <>{record?.invite?.user?.referrals?.length ? moment(record?.invite?.user?.referrals?.[0]?.createdAt).format('DD/MM/YYYY') : ""}</>
            },
        },
        {
            title: 'Outstanding Payment',
            dataIndex: '',
            key: '',
            render: (text) => {
                return isAdminEmail(text?.invite?.email) ? "" :  <>
                    {text?.outstanding > 0 && <Tag color='red'>{text?.outstanding}</Tag>}
                    {text?.outstanding === 0 && <Tag color='green'>{text?.outstanding}</Tag>}
                </>
            },
        },
        {
            title: 'Total Income Referred',
            dataIndex: '',
            key: '',
            render: (text) => {
                return isAdminEmail(text?.invite?.email) ? "" :  <>{text?.totalIncome}</>
            },
        },
        {
            title: 'Action',
            key: 'action',
            render: (_, record: any) => {
                return <Space size="middle">
                    {userRoleId === 2 && <Button type='default' disabled={!record?.outstanding} className='btn btn-outline-primary-md' onClick={() => paymentHandler({show: true, data: record})}>
                        <BankOutlined /> Pay
                    </Button>}
                    {userRoleId === 1 && <Button type='default' disabled={!record?.outstanding} className='btn btn-outline-primary-md' onClick={() => paymentHandler({show: true, data: record})}>
                        <BankOutlined /> Pay
                    </Button>}
                </Space>
            },
        },
    ];


    const handleSearch =(data:any)=> {
        getReferrerData(data);
    }

    const paymentHandler =(values:any)=> {
        if(userRoleId ===1) {
            let paymentPayload = {
                adminId: values?.data?.adminId, 
            }
            dispatch(
                paySuperAdminReferrers(paymentPayload, (resp: any) => {
                    if (resp?.success) {
                        getReferrerData({})
                    }
                })
            );
        } else {
            setShowPaymentModal(values);
        }
    }

    const handleDeleteAdminReferrer =(deleteData:any)=> {
        if(userRoleId === 2) dispatch(deleteBusinessReferrerAction({id: deleteData?.invite_id}, (resp:any)=> { if(resp) getReferrerData({}) }))
        if(userRoleId === 1) dispatch(deleteSuperAdminReferrerAction({id: deleteData?.id}, (resp:any)=> { if(resp) getReferrerData({}) }))
      }

    const tableComponent = (
        <div className="responsivetable">
            {showOnlyTable ? <Table
                size='small'
                columns={userRoleId === 1 ? superAdminColumns : columns}
                dataSource={data}
                loading={isLoading}
                pagination={{
                    total: pagination?.totalItems || 0,
                    pageSize,
                    current: page,
                    showSizeChanger: true,
                    pageSizeOptions: ['20', '50'],
                }}
                scroll={{ y: 264, x: 800 }}
                onChange={handleTableChange}
                rowKey='email'
            /> :
                <>
                    <div className='item-wrapper'>
                        {data?.map((item: any, index: number) => {
                            let itemData = userRoleId === 1 ? convertToBusinessFormat(item) : item;
                            return (
                                <ListingCardReferrer handleDeleteAdminReferrer={handleDeleteAdminReferrer} handleSendEmailReminder={(e: any) => handleSendEmailReminder(e)} isReferral={false} handleModal={(inpt: any) => paymentHandler(inpt)} data={itemData} key={index} showViewMore={true} isMyReferrers={true} />
                            )
                        })}
                    </div>
                    {data?.length === 0 && <div style={{ textAlign: 'center' }}><Empty /></div>}
                </>
             }
        </div>
    );

    const handleExport = () => {
            const payload = { role: userRoleId };
    
            dispatch(
                exportMyReferrersAction(payload, (resp: any) => {
                    if (resp?.status === 200 && resp?.data) {
                        // Create a blob from the response data
                        const blob = new Blob([resp.data], { type: 'text/csv' });
    
                        // Create a download link
                        const url = window.URL.createObjectURL(blob);
                        const link = document.createElement('a');
                        link.href = url;
    
                        // Optional: use Content-Disposition header for filename if available
                        const fileName = `my_referrers_${Date.now()}.csv`;
                        link.setAttribute('download', fileName);
    
                        document.body.appendChild(link);
                        link.click();
                        link.remove();
                        window.URL.revokeObjectURL(url); // Clean up
    
                        message.success('Export successful!');
                    } else if (resp?.status === 404) {
                        message.warning('No business records found.');
                    } else {
                        message.error('Export failed.');
                    }
                })
            );
        };

    return (
        <div>
            {
                showOnlyTable ? tableComponent :
                    <>
                        <Header pagTitle="Let’s see my referrers" />
                        <div className="contentBody">
                            <div className="bodycard">
                                <PageTitle buttonLabel='Invite A Referrer' pagTitle="My Referrers" button={true} buttonLink={'/invite-a-referrer'} />
                                {/* <PageTitle buttonLabel='Invite A Referrer' pagTitle="My Referrers" button={true} buttonLink={'/invite-a-referrer'} exportButton={true} handleExport={handleExport} /> */}
                                <div className='pl-24' style={{ float: "right" }}>
                                   
                                </div>
                                <div className=''>
                                    <SearchFilter
                                        searchTitle="Name, Email"
                                        filterList={advanceFilterReferrerList}
                                        onSearch={(searchValue) => {
                                            // Handle the search value here
                                            console.log(searchValue);
                                            handleSearch(searchValue)
                                        }}
                                    />
                                </div>
                                <div className="cardContentbody">
                                    {isLoading ? <Spin style={{ padding: '25px', textAlign: 'center', display: 'block' }}></Spin> : tableComponent}
                                    <div>
                                        <CardPagination activePage={page} total={pagination?.totalItems || 0} handleChange={handleTableChange} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>}

                    <PaymentModal refetchData={getReferrerData} isReferral={false} visible={showPaymentModal} setVisible={()=>setShowPaymentModal({...showPaymentModal, show: !showPaymentModal})} />
        </div>
    );
};

export default MyReferrers;
